import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {teamTableReady,rowsPerPageState,searchTextState,paginationState,teamEmployeeIdForAction,attritionSourceAction} from '../redux/teams'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/teamsTable.css'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(teamsData) {
    let array = []
    if (teamsData && teamsData.data && teamsData.data.list) {
        array = teamsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.code = lineData.code ? lineData.code : "NA"
            newLineData.designation_name=lineData.designation && lineData.designation.name ? lineData.designation.name : "NA"
            newLineData.mobile =lineData.mobile ? lineData.mobile : "NA"
            newLineData.email =lineData.email ? lineData.email : "NA"
            newLineData.department_name =lineData.department && lineData.department.name ? lineData.department.name : "NA"
            newLineData.reporting_manager_name =lineData.reporting_manager && lineData.reporting_manager.name ? lineData.reporting_manager.name : "NA"
            newLineData.city_name =lineData.city && lineData.city.name ? lineData.city.name : "NA"
            newLineData.email =lineData.email ? lineData.email : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"

            newArray[i] = newLineData
        }
    }
    return newArray
}


class TeamsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            teamData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(teamTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.TEAMS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getTeamsData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getTeamsData = () => {
        apiService.getTeamsData()
            .then(teamsData => {
                if (teamsData && this.isComponentMounted) {
                    this.validateBuildNumber(teamsData)
                    if (teamsData.status === "SUCCESS") {
                        let array = filterUnwantedData(teamsData), pageNo = 1
                        if (this.props.teams && this.props.teams.previousPaginationValue) {
                            pageNo = this.props.teams.previousPaginationValue
                        }
                        this.setState({
                            teamData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: teamsData.reason ? teamsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(teamTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(teamTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.teams && this.props.teams.previousRowsPerPageValue) {
            value = this.props.teams.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                 {/*  <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.history.push("/dashboard/employees/teams/addAttendance")
                            }}>
                            Add Attendance
                        </button>
                    </div>
                */}

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
   
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.teamData.length>=(this.props.teams.previousPaginationValue*this.props.teams.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.teams.previousPaginationValue*this.props.teams.previousRowsPerPageValue)-this.props.teams.previousRowsPerPageValue+1} to {this.props.teams.previousPaginationValue*this.props.teams.previousRowsPerPageValue} of {this.state.teamData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.teams.previousPaginationValue*this.props.teams.previousRowsPerPageValue)-this.props.teams.previousRowsPerPageValue+1} to {this.state.teamData.length} of {this.state.teamData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }
    getFilteredBrandList = () => {
       
        this.props.dispatch(teamTableReady(false))
        this.resetSearchAndPagination()
        this.getTeamsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getTeamsData()
        this.props.dispatch(teamTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }


     addAttrition = (row) => {
        if (row && row.id) {
            this.props.dispatch(teamEmployeeIdForAction(row.id))            
            this.props.dispatch(attritionSourceAction("MyTeam"))
            this.props.history.push("/dashboard/employees/addAttrition")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }




    actionButtonsCreator = (cell, row) => {

        let attritionEmployee=""
      
        if(row.status==="ACTIVE"){


    if(Helpers.checkPrivileges("/dashboard/employees/addAttrition",this.props.user)){

                attritionEmployee =<button
                title="Employee Attrition"
                className="action-button btn-warning"
                style={{ marginBottom: "1px", background : "red"}}
                onClick={(e) => {
                    e.preventDefault()
                    this.addAttrition(row)
                }}>
                <i title="Employee Attrition" className="fa fa-trash" aria-hidden="true"> Attrition</i>
            </button>
        }
            }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{attritionEmployee}</div>
        </div>)
    }
     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.teams && this.props.teams.previousPaginationValue
            && this.props.teams.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editBrand = (row) => {
        if (row && row.id) {
            this.props.dispatch(teamEmployeeIdForAction(row.id))
            this.props.history.push("/dashboard/team/addedit")
        } else {
            this.dialog.show({
                title: "Brand Identification number not found",
                body: 'Brand id is not available, So not able edit team',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.teams && this.props.teams.previousRowsPerPageValue) {
            sizeperPage = this.props.teams.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="teams-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.teamData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                    

                      <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="code"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Id
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="email"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Email
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="mobile"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Mobile
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="city_name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="department_name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Department
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="designation_name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Designation
                    </TableHeaderColumn>                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        teams: state.teams
    }
}

export default connect(mapStateToProps)(withRouter(TeamsTable))


// WEBPACK FOOTER //
// ./src/modules/Teams/Components/TeamsTable.js